export type NormalizeCatalogNumericsParams<T> = {
	records: Record<string, T>;
	field: keyof T;
};

/**
 * Coerces one numeric field across a snapshot collection, mirroring the `Number(value) || 0` pass
 * every catalog singleton runs in its own `loadData` -- a persisted price book payload can carry
 * msrp as a string, and an uncoerced string would flow straight into the estimate arithmetic.
 * @param params records to normalize and the numeric field to coerce
 * @returns a new record map with the field coerced on every entry
 */
export const normalizeCatalogNumericsCfn = <T>(params: NormalizeCatalogNumericsParams<T>): Record<string, T> => {
	const { records, field } = params;
	return Object.fromEntries(Object.entries(records).map(([key, record]) => [key, { ...record, [field]: Number(record[field]) || 0 }]));
};
